import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppFrameComponent } from '../app/page-modules/app-frame/app-frame.component';
import { HeaderComponent } from '../app/frame-modules/header/header.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { HeaderActionsComponent } from '../app/frame-modules/header/header-actions/header-actions.component';
import { UserMenuComponent } from '../app/frame-modules/header/header-actions/user-menu/user-menu.component';
import { FilesManagementComponent } from '../app/page-modules/files-management/files-management.component';
import { MatTableModule } from '@angular/material/table';
import {
  TablePopupComponent
} from '../app/page-modules/requests-overview/overview-table/table-popup/table-popup.component';
import ContactDetailsComponent from '../app/page-modules/contact-details/contact-details.component';
import { AttachmentsComponent } from '../app/page-modules/contact-details/attachments/attachments.component';
import { LinkComponent } from '../app/page-modules/contact-details/link/link.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { UserProfileComponent } from '../app/page-modules/user-profile/user-profile.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { SharedModule } from './shared.module';
import { UserRightsComponent } from '../app/page-modules/user-rights/user-rights.component';
import { UserCardComponent } from '../app/page-modules/user-rights/user-card/user-card.component';
import { HistoryCommentComponent } from '../app/page-modules/contact-details/comment/comment.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { SearchComponent } from '../app/page-modules/requests-overview/search/search.component';
import {
  SearchAdditionaryComponent
} from '../app/page-modules/requests-overview/overview-table/search-additionary/search-additionary.component';
import {
  OrderOfferDialogComponent
} from '../app/page-modules/contact-details/extended-properties/order-offer-dialog.component';
import { InfoSideBarComponent } from '../app/page-modules/contact-details/info-side-bar/info-side-bar.component';
import { UpdateBannerComponent } from '../app/frame-modules/header/update-banner/update-banner.component';
import { BrochureSampleComponent } from "../app/page-modules/contact-details/brochure-sample/brochure-sample.component";
import { ForwardUserComponent } from "../app/page-modules/user-profile/forward-user/forward-user.component";
import { ErrorComponent } from '../app/page-modules/contact-details/error/error.component';
import { HistoryNoteComponent } from '../app/page-modules/contact-details/comment/note/note.component';
import { DeleteConfirmComponent } from '../app/page-modules/contact-details/delete-confirm/delete-confirm.component';
import { DateFilterComponent } from '../app/page-modules/requests-overview/date-filter/date-filter.component';
import { MatDividerModule } from "@angular/material/divider";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { OrderOfferComponent } from "../app/page-modules/contact-details/order-offer/order-offer.component";
import { AdministrationComponent } from '../app/page-modules/administration/administration.component';
import {
  OrganizationalUnitsComponent
} from '../app/page-modules/administration/organizational-units/organizational-units.component';
import { AreasComponent } from '../app/page-modules/administration/areas/areas.component';
import { DuplicatesComponent } from '../app/page-modules/administration/duplicates/duplicates.component';
import { UserDetailsComponent } from '../app/page-modules/user-rights/user-details/user-details.component';
import {
  DeactivateDialogComponent
} from '../app/page-modules/user-rights/deactivate-dialog/deactivate-dialog.component';
import {
  RequestsOverviewContentComponent
} from '../app/page-modules/requests-overview/requests-overview-content/requests-overview-content.component';
import {
  RequestsOverviewDesktopContainerComponent
} from '../app/page-modules/requests-overview/requests-overview-content/requests-overview-desktop-container/requests-overview-desktop-container.component';
import {
  RequestsOverviewMobileContainerComponent
} from '../app/page-modules/requests-overview/requests-overview-content/requests-overview-mobile-container/requests-overview-mobile-container.component';
import {
  RequestsOverviewTopBarComponent
} from '../app/page-modules/requests-overview/requests-overview-top-bar/requests-overview-top-bar.component';
import {
  RequestsOverviewMobileFilterOverlayComponent
} from '../app/page-modules/requests-overview/requests-overview-mobile-filter-overlay/requests-overview-mobile-filter-overlay.component';
import {
  RequestsOverviewFilterChipsComponent
} from '../app/page-modules/requests-overview/requests-overview-filter-chips/requests-overview-filter-chips.component';
import {
  TablePopupOldComponent
} from '../app/page-modules/requests-overview/overview-table/table-popup-old/table-popup-old.component';
import { PrintDetailsComponent } from '../app/page-modules/contact-details/print-details/print-details.component';
import { TagsComponent } from '../app/page-modules/contact-details/tags/tags.component';
import { ContactDetailBreadcrumb } from '../app/page-modules/contact-details/breadcrumb/breadcrumb.component';
import {
  RequestInvitationPreviewComponent
} from '../app/page-modules/request-invitation-preview/request-invitation-preview.component';
import { CanDeactivateGuard } from '../guards/can-deactive.guard';
import { ContactActionsComponent } from '../app/page-modules/contact-details/contact-actions/contact-actions.component';
import {
  ContactTypeCardComponent
} from '../app/page-modules/contact-details/contact-type-card/contact-type-card.component';
import {
  ContactOrderCardComponent
} from '../app/page-modules/contact-details/contact-order-card/contact-order-card.component';
import {
  RelatedLeadsHistoryComponent
} from '../app/page-modules/contact-details/related-leads/related-leads-history.component';
import {
  ComposerChangesComponent
} from '../app/page-modules/contact-details/comment/composer-changes/composer-changes.component';
import { NotAllowedDetailComponent } from '../app/page-modules/not-allowed-detail/not-allowed-detail.component';
import {
  BrokerAssignConfirmComponent
} from '../app/page-modules/contact-details/broker-assign-confirm/broker-assign-confirm.component';

const routes: Routes = [
  {
    path: '',
    component: AppFrameComponent,
    children: [
      {
        path: '',
        component: RequestsOverviewContentComponent
      },
      {
        path: 'details/:id',
        canDeactivate: [CanDeactivateGuard],
        component: ContactDetailsComponent
      },
      {
        path: 'request-invitation-preview/:leadId',
        canDeactivate: [CanDeactivateGuard],
        component: RequestInvitationPreviewComponent
      },
      {
        path: 'not-allowed-details',
        canDeactivate: [CanDeactivateGuard],
        component: NotAllowedDetailComponent
      },
      {
        path: 'profile',
        canDeactivate: [CanDeactivateGuard],
        component: UserProfileComponent
      },
      {
        path: 'administration',
        canDeactivate: [CanDeactivateGuard],
        component: AdministrationComponent
      },
      {
        path: 'profileData-rights',
        canDeactivate: [CanDeactivateGuard],
        component: UserRightsComponent
      },
      {
        path: 'profileData-rights/:id',
        canDeactivate: [CanDeactivateGuard],
        component: UserDetailsComponent
      },
    ]
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: ''
  }
];


const MATERIAL_MODULES = [
  MatIconModule,
  MatInputModule,
  MatButtonModule,
  MatSelectModule,
  MatToolbarModule,
  MatMenuModule,
  MatTableModule,
  MatDialogModule,
  MatTabsModule,
  MatSidenavModule,
  MatProgressSpinnerModule,
  MatTooltipModule,
  MatDividerModule,
  MatProgressBarModule,
];


@NgModule({
  declarations: [
    AppFrameComponent,
    HeaderComponent,
    HeaderActionsComponent,
    UserMenuComponent,
    RequestsOverviewContentComponent,
    RequestsOverviewDesktopContainerComponent,
    RequestsOverviewMobileContainerComponent,
    RequestsOverviewTopBarComponent,
    RequestsOverviewMobileFilterOverlayComponent,
    RequestsOverviewFilterChipsComponent,
    RequestInvitationPreviewComponent,
    NotAllowedDetailComponent,
    ContactActionsComponent,
    ContactTypeCardComponent,
    ContactOrderCardComponent,
    ContactDetailsComponent,
    ContactDetailBreadcrumb,
    PrintDetailsComponent,
    OrderOfferComponent,
    InfoSideBarComponent,
    AttachmentsComponent,
    LinkComponent,
    TagsComponent,
    ErrorComponent,
    DeleteConfirmComponent,
    BrokerAssignConfirmComponent,
    OrderOfferDialogComponent,
    BrochureSampleComponent,
    HistoryCommentComponent,
    ComposerChangesComponent,
    RelatedLeadsHistoryComponent,
    HistoryNoteComponent,
    FilesManagementComponent,
    OrganizationalUnitsComponent,
    AreasComponent,
    DuplicatesComponent,
    SearchComponent,
    DateFilterComponent,
    SearchAdditionaryComponent,
    TablePopupComponent,
    TablePopupOldComponent,
    UserProfileComponent,
    AdministrationComponent,
    ForwardUserComponent,
    UserRightsComponent,
    UserDetailsComponent,
    UserCardComponent,
    UpdateBannerComponent,
    DeactivateDialogComponent,
  ],
  imports: [
    RouterModule.forRoot(routes),
    FormsModule,
    ReactiveFormsModule,
    ...MATERIAL_MODULES,
    SharedModule,
    ClipboardModule,
    CommonModule,
  ],
  exports: [MatDialogModule]
})
export class AppRoutingModule {
}
